import CloudHero from './CloudHero';

export default CloudHero;
